<template>
	<div :class="$style.leftPetInfo">
		<el-tabs v-model="cloneActiveName"
			:class="containerGroupPetId.length > 4 ? 'orderformSection__left__content__tabMorePadding' : ''"
			class="orderformSection__left__content__tab" stretch @tab-click="emitHandleClickPetTab">
			<template v-if="showAdd && !$store.getters['modifyOrder/isModified']">
				<el-tab-pane>
					<div slot="label">
						<p>+</p>
					</div>
				</el-tab-pane>
			</template>
			<template v-if="containerGroupPetId.length > 0">
				<el-tab-pane v-for="item in containerGroupPetId" :key="item.id" :class="$style.tab">
					<div slot="label" class="tabHeader">
						<div v-if="countShow" :class="$style['tab__count']">
							<p v-if="$store.getters['modifyOrder/isModified']">1</p>
							<p v-else>{{ serviceCountByPet[item.id].length }}</p>
						</div>
						<el-avatar :src="item.avatar"></el-avatar>
						<span :class="$style['tab__name']">{{ item.name }}</span>
					</div>
				</el-tab-pane>
			</template>
		</el-tabs>
	</div>
</template>

<script>
export default {
	name: 'LeftPetTab',
	data() {
		return {
			cloneActiveName: ''
		};
	},
	props: {
		containerGroupPetId: {
			type: Array,
			default: () => {
				return []
			},
			require: true
		},
		activeName: {
			type: String,
			default: ""
		},
		showAdd: {
			type: Boolean
		},
		serviceCountByPet: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	watch: {
		activeName(nvl) {
			this.cloneActiveName = nvl
		},
	},
	mounted() {
	},
	computed: {
		seeAllOrderText() {
			if (this.activeName === '') {
				return '查看右側總訂單中'
			} else {
				return '查看總訂單'
			}
		},
		countShow() {
			if (this.serviceCountByPet && Object.keys(this.serviceCountByPet).length > 0) {
				return true
			} else {
				return false
			}
		}
	},
	created() { },
	methods: {
		/**
		 * @description 發送tab資料上去
		 */
		emitHandleClickPetTab() {
			this.$emit('updateActiveName', this.cloneActiveName)
			this.$emit('handleClickPetTab')
		}
	},
	components: {},
};
</script>

<style lang="scss" module>
.leftPetInfo {
	background-color: white;

	:global {
		.el-avatar {
			width: 42px;
			height: 42px;
		}
	}
}

.seeAll {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 20px 44px;
	width: 100%;

	:global {
		.el-button {
			width: 100%;
		}
	}
}

.allPet {
	>p {
		font-size: 15px !important;
	}
}

.tab {
	&__count {
		position: absolute;
		background-color: $color-primary;
		color: white;
		width: 22px;
		height: 22px;
		border-radius: 50%;
		top: 10px;
		right: 20px;
		display: flex;
		justify-content: center;
		align-items: center;

		>p {
			font-size: 16px !important;
		}
	}

	&__name {
		margin-top: -10px;
	}
}
</style>
